export enum ActivityEnum {
  COMPANY_DISTRIBUTOR = 'DISTRIBUTOR',
  COMPANY_SUPPLIER = 'SUPPLIER',
  COMPANY_PRINTING_OFFICE = 'PRINTING_OFFICE',
  COMPANY_MILLING_OFFICE = 'MILLING_OFFICE',
  COMPANY_MANUFACTURER = "MANUFACTURER",
  COMPANY_ORDERPICKER = "ORDERPICKER",
  COMPANY_SHIPPER = "SHIPPER"
}
